<script>
import { VueMaskDirective as mask } from 'v-mask'
import ClickOut from '../../../../utils/directives/clickout'
import ReboquistaService from '../../../../domain/reboquista/services/reboquista'
import UPagination from '../../../_default/components/Uloc/Pagination'
import { forEach as _forEach, debounce } from 'lodash'
import { Loader } from '@googlemaps/js-api-loader'
import http from '../../../../utils/services/http'
import ACL from '../../../../domain/acl/tmp-acl'
import { currentUser } from '../../../../domain/auth/store/getters'

export default {
  components: {
    UPagination
  },
  name: 'Reboquista',
  directives: { mask, ClickOut },
  data () {
    return {
      openCFilter: false,
      showFiltros: false,
      isLoading: false,
      data: null,
      paginationLimits: [25, 50, 100],
      pagination: {
        totalPages: 0,
        totalItems: 0,
        atualPage: 1,
        limit: 25
      },
      checkeds: 0,
      checkedAll: false,
      filtros: {
        busca: ''
      },
      filterKey: '',
      sortKey: '',
      sortOrders: {
        'numero': 1,
        'titulo': 1,
        'comitente': 1
      },
      prevent: {},
      dblclick: 0,

      // Controle do modal e Google Maps
      showModalLocalizacao: false,
      modalReboquista: null,
      dataInicial: '',
      dataFinal: '',
      localizacoes: [],
      mapMarkers: [],
      google: null,
      map: null,
      googleMapsLoader: null
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  computed: {
    filteredData: function () {
      let sortKey = this.sortKey
      let filterKey = this.filterKey && this.filterKey.toLowerCase()
      let order = this.sortOrders[sortKey] || 1
      let data = this.data
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return data
    },
    noData () {
      if (this.data === null) {
        return false
      }
      if (this.data.length === 0) {
        return true
      }
      return false
    },

    // ...mapGetters(['isLogged', 'currentUser']),

    permisaoAcl () {
      return ACL.check('historico-reboquista', currentUser.id)
    }
  },
  mounted () {
    this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
  },
  activated () {},
  methods: {
    reload () {
      this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    loading (v) {
      this.isLoading = !!v
    },

    nextElement ({target}) {
      let index = parseInt(target.getAttribute('tabindex'))
      let next = index + 1
      document.querySelector('[tabindex="' + next + '"').focus()
    },
    open (id) {
      this.$router.push({name: 'config.reboquista.edit', params: {id: id}})
    },

    load (limit, page, filtros) {
      this.data = null
      this.isLoading = true
      ReboquistaService.list(limit, page, filtros)
        .then((response) => {
          this.isLoading = false
          console.log(response.data)
          this.data = response.data.result
          this.pagination.atualPage = response.data.offset
          this.pagination.totalPages = response.data.totalPages
          this.pagination.totalItems = response.data.total
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },

    changePage (page) {
      console.log('Change page ', page)
      this.pagination.atualPage = page
      this.load(this.pagination.limit, page, this.montaFiltros())
    },

    checkAll (o) {
      this.$nextTick(() => {
        let ca = this.checkedAll
        if (ca === true) {
          this.checkeds = o.length
        } else {
          this.checkeds = 0
        }
        _forEach(o, (item, key) => {
          this.$set(this.data, key, Object.assign({}, this.data[key], {selected: ca}))
        })
      })
    },
    lazyCheck (l) {
      this.$nextTick(() => {
        if (l.selected) {
          this.checkeds += 1
        } else {
          this.checkeds -= 1
        }
        this.checkedAll = (this.checkeds === this.data.length)
      })
    },

    montaFiltros () {
      let filtros = this.filtros
      let mount = ''
      if (filtros.busca.length > 0) {
        mount += '&busca=' + filtros.busca
      }
      console.log(filtros.busca)
      return mount
    },
    deletar () {
      var r = confirm('Tem certeza que deseja deletar este reboquista?')
      if (r) {
        var toDelete = document.getElementsByName('post[]')
        toDelete.forEach(
          function (currentValue) {
            if (currentValue.checked) {
              ReboquistaService.delete(currentValue.value)
                .then(() => {
                  alert('Reboquista deletado com sucesso')
                })
                .catch((response) => {
                  alert('Erro ao deletar o reboquista')
                  alert(response.data.errors)
                  console.log(response)
                })
            }
          })
        this.reload()
      }
    },

    pesquisar: debounce(function () {
      let busca = this.filtros.busca
      if (this.prevent.busca === busca) {
        return
      }
      this.prevent.busca = busca
      this.pagination.atualPage = 1
      this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    }, 500),

    // MÉTODOS DO MODAL
    abrirModalLocalizacao (reboquista) {
      this.modalReboquista = reboquista
      this.showModalLocalizacao = true
      this.localizacoes = []
      this.mapMarkers = []
      this.dataInicial = ''
      this.dataFinal = ''

      // Aguarda o Vue atualizar o DOM antes de recriar o mapa
      this.$nextTick(() => {
        if (this.map) {
          this.map = null // Remove referência do mapa para garantir recriação
        }

        setTimeout(() => {
          this.initGoogleMaps()
        }, 300)
      })
    },
    fecharModalLocalizacao () {
      this.showModalLocalizacao = false
    },

    async initGoogleMaps () {
      if (!this.googleMapsLoader) {
        this.googleMapsLoader = new Loader({
          apiKey: 'AIzaSyDOSOhYdt1eYdix6HnWNujnrturXzszatI',
          version: 'weekly',
          libraries: ['places', 'geometry']
        })
      }

      if (!this.google) {
        this.google = await this.googleMapsLoader.load()
      }

      if (!this.map) {
        this.map = new this.google.maps.Map(this.$refs.mapContainer, {
          center: {lat: -22.9, lng: -43.2},
          zoom: 12,
          mapTypeId: 'roadmap',
          gestureHandling: 'greedy', // Permite arrastar com o botão direito
          disableDefaultUI: false
        })
      }
    },

    buscarLocalizacaoPorPeriodo () {
      if (!this.modalReboquista || !this.dataInicial || !this.dataFinal) {
        alert('Selecione as datas e tente novamente.')
        return
      }

      const {id} = this.modalReboquista
      const url = `/api/reboquista/${id}/localizacao-por-periodo?dataInicial=${this.dataInicial}&dataFinal=${this.dataFinal}`

      http.get(url)
        .then(response => {
          this.localizacoes = response.data
          this.plotarLocalizacoesNoMapa()
        })
        .catch(err => {
          console.error(err)
          alert('Erro ao buscar histórico de localizações.')
        })
    },

    plotarLocalizacoesNoMapa () {
      if (!this.google || !this.map) return

      // Remove marcadores antigos
      this.mapMarkers.forEach(marker => marker.setMap(null))
      this.mapMarkers = []
      if (this.mapPolyline) {
        this.mapPolyline.setMap(null)
      }

      if (!this.localizacoes || this.localizacoes.length === 0) {
        alert('Nenhum ponto de localização encontrado neste período.')
        return
      }

      const bounds = new this.google.maps.LatLngBounds()
      const polylinePath = []

      // Calcula a distância total percorrida
      let totalDistance = 0
      for (let i = 1; i < this.localizacoes.length; i++) {
        const prev = this.localizacoes[i - 1]
        const curr = this.localizacoes[i]

        const prevPos = new this.google.maps.LatLng(parseFloat(prev.lat), parseFloat(prev.lng))
        const currPos = new this.google.maps.LatLng(parseFloat(curr.lat), parseFloat(curr.lng))

        totalDistance += this.google.maps.geometry.spherical.computeDistanceBetween(prevPos, currPos)
      }

      // Ajusta `sampleSize` com base na distância total E na quantidade de pontos
      let totalPoints = this.localizacoes.length
      let sampleSize

      if (totalPoints <= 20) {
        sampleSize = 1
      } else if (totalDistance < 5000) { // Menos de 5km
        sampleSize = Math.max(1, Math.floor(totalPoints / 6))
      } else if (totalDistance < 20000) { // Entre 5km e 20km
        sampleSize = Math.max(1, Math.floor(totalPoints / 10))
      } else if (totalDistance < 50000) { // Entre 20km e 50km
        sampleSize = Math.max(1, Math.floor(totalPoints / 15))
      } else { // Acima de 50km
        sampleSize = Math.max(1, Math.floor(totalPoints / 20))
      }

      // Processa os pontos
      this.localizacoes.forEach((loc, index) => {
        const lat = parseFloat(loc.lat)
        const lng = parseFloat(loc.lng)
        const dataHora = new Date(loc.data.date).toLocaleString('pt-BR')

        if (!isNaN(lat) && !isNaN(lng)) {
          const position = new this.google.maps.LatLng(lat, lng)
          polylinePath.push(position)

          if (index === 0 || index === this.localizacoes.length - 1 || index % sampleSize === 0) {
            let iconUrl = 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
            let labelText = `
          <div style="display: flex; align-items: center; justify-content: space-between; width: 220px;">
            <span><strong>Data:</strong> ${dataHora}</span>
            <button id="closeInfoWindow" style="border: none; background: none; font-size: 14px; cursor: pointer; color: #555;">❌</button>
          </div>
        `

            if (index === 0) {
              iconUrl = 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
              labelText = `
            <div style="display: flex; align-items: center; justify-content: space-between; width: 220px;">
              <span><strong>Data:</strong> ${dataHora} <br><strong style="color: green;">(Início)</strong></span>
              <button id="closeInfoWindow" style="border: none; background: none; font-size: 14px; cursor: pointer; color: #555;">❌</button>
            </div>
          `
            }
            if (index === this.localizacoes.length - 1) {
              iconUrl = 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
              labelText = `
            <div style="display: flex; align-items: center; justify-content: space-between; width: 220px;">
              <span><strong>Data:</strong> ${dataHora} <br><strong style="color: blue;">(Final)</strong></span>
              <button id="closeInfoWindow" style="border: none; background: none; font-size: 14px; cursor: pointer; color: #555;">❌</button>
            </div>
          `
            }

            const marker = new this.google.maps.Marker({
              position,
              map: this.map,
              icon: {
                url: iconUrl,
                scaledSize: new this.google.maps.Size(40, 40)
              }
            })

            let infoWindow = new this.google.maps.InfoWindow({disableAutoPan: true})
            marker.addListener('click', () => {
              if (this.activeInfoWindow) {
                this.activeInfoWindow.close()
              }

              infoWindow.setContent(`<div id="infoWindow">${labelText}</div>`)
              infoWindow.open(this.map, marker)
              this.activeInfoWindow = infoWindow

              setTimeout(() => {
                document.getElementById('closeInfoWindow').addEventListener('click', () => {
                  infoWindow.close()
                  this.activeInfoWindow = null
                })
              }, 100)
            })

            this.mapMarkers.push(marker)
          }

          bounds.extend(position)
        }
      })

      // Criar a linha conectando os pontos
      this.mapPolyline = new this.google.maps.Polyline({
        path: polylinePath,
        geodesic: true,
        strokeColor: '#FF5733',
        strokeOpacity: 1,
        strokeWeight: 4,
        map: this.map
      })

      // Evento para fechar a InfoWindow ao clicar fora
      this.map.addListener('click', () => {
        if (this.activeInfoWindow) {
          this.activeInfoWindow.close()
          this.activeInfoWindow = null
        }
      })

      if (this.localizacoes.length === 1) {
        this.map.setCenter(bounds.getCenter())
        this.map.setZoom(18)
      } else {
        this.map.fitBounds(bounds)
        if (this.map.getZoom() > 16) {
          this.map.setZoom(16)
        }
      }
    }
  }
}
</script>

<style>
.gm-style-iw-c button[aria-label="Fechar"],
.gm-ui-hover-effect {
  display: none !important;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-container {
  background: white;
  width: 80%;
  max-width: 1100px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  padding: 15px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #ddd;
}

.close {
  font-size: 32px;
  cursor: pointer;
  color: #666;
  background: none;
  border: none;
  padding: 5px;
  margin-left: auto;
  transition: color 0.3s ease-in-out;
}

.modal-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 15px;
  overflow: hidden;
}

.map-fullscreen {
  flex-grow: 1;
  width: 100%;
  height: 100%;
  min-height: 530px;
  border-radius: 5px;
  border: 1px solid #ddd;
}
</style>

<template>
  <!-- Necessário um container único para o transition -->
  <transition name="slide" appear>
    <div>
      <!-- TODO o conteúdo principal da tela -->
      <div class="app-content-body fade-in-up content-transition">
        <div class="hbox hbox-auto-xs hbox-auto-sm">
          <div class="col">
            <div class="r">

              <div class="bg-light lter b-b wrapper-md">
                <div class="row">
                  <div class="col-sm-6 col-xs-12">
                    <h1 class="font-thin h3">
                      Reboquista <span class="badge">{{ pagination.totalItems }}</span>
                    </h1>
                    <small class="text-muted">
                      <!--<ordenar-arrematante></ordenar-leilao>-->
                    </small>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <div class="text-right text-left-xs">
                      <router-link
                        :to="{ name: 'config.reboquista.novo' }"
                        tag="button"
                        class="btn btn-default btn-sm"
                      >
                        <i class="fa fa-plus"></i>
                        Novo reboquista
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="panel panel-default">
                <div class="wrapper clearfix">
                  <div class="col-sm-7 m-b-xs">
                    <div class="btn-group dropdown">
                      <button
                        type="button"
                        class="btn btn-sm btn-default"
                        disabled
                        data-toggle="dropdown"
                      >
                        Exportar
                        <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu">
                        <li><a href="">Dropdown link</a></li>
                        <li><a href="">Dropdown link</a></li>
                        <li><a href="">Dropdown link</a></li>
                      </ul>
                    </div>
                    <button
                      class="btn btn-sm btn-default"
                      aria-disabled="true"
                      @click="deletar"
                    >
                      Deletar
                    </button>
                  </div>
                  <div class="col-sm-5">
                    <div class="input-group">
                      <div class="input-group-btn">
                        <a class="btn btn-sm btn-default">
                          <span class="m-r-xs font-bold"></span>Filtros
                        </a>
                      </div>
                      <input
                        type="text"
                        class="input-sm form-control"
                        v-model="filtros.busca"
                        @keyup="pesquisar"
                        placeholder="Pesquisar"
                      >
                      <span class="input-group-btn">
                        <button class="btn btn-sm btn-default" type="button">
                          Buscar
                        </button>
                      </span>
                    </div>
                  </div>
                </div>

                <!--<div class="wrapper m-b-n m-t-n text-right">
                  <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                :total="pagination.totalPages"></u-pagination>
                </div>-->

                <div class="table-responsive">
                  <table class="table table-hover table-striped b-t b-light">
                    <thead>
                    <tr>
                      <th style="width:20px;">
                        <label class="i-checks m-b-none">
                          <input
                            type="checkbox"
                            @change="checkAll(data)"
                            v-model="checkedAll"
                            tabindex="0"
                            aria-checked="false"
                            aria-invalid="false"
                          ><i></i>
                        </label>
                      </th>
                      <th>Id</th>
                      <th>Nome</th>
                      <th>CNH</th>
                      <th>Codigo</th>
                      <th>Ativo</th>
                      <th v-if="permisaoAcl">Histórico do Reboquista</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!-- FAKE -->
                    <tr v-if="isLoading" v-for="i in [1,2,3]" :key="i">
                      <td class="v-middle">
                        <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                      </td>
                      <td role="button" tabindex="0">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </td>
                    </tr>

                    <tr v-for="Reboquista in filteredData" :key="Reboquista.id">
                      <td class="v-middle">
                        <label class="i-checks m-b-none">
                          <input
                            v-on:click.stop="lazyCheck(Reboquista)"
                            type="checkbox"
                            name="post[]"
                            v-model="Reboquista.selected"
                            tabindex="0"
                            aria-checked="false"
                            aria-invalid="false"
                            :value="Reboquista.id"
                          >
                          <i></i>
                        </label>
                      </td>
                      <td
                        @click="open(Reboquista.id)"
                        role="button"
                        tabindex="0"
                      >
                        {{ Reboquista.id }}
                      </td>
                      <td
                        @click="open(Reboquista.id)"
                        role="button"
                        tabindex="0"
                      >
                        <a class="text-cap custom-link ">
                          {{ Reboquista.nome }}
                        </a>
                      </td>
                      <td
                        @click="open(Reboquista.id)"
                        role="button"
                        tabindex="0"
                      >
                        {{ Reboquista.cnh }}
                      </td>
                      <td
                        @click="open(Reboquista.id)"
                        role="button"
                        tabindex="0"
                      >
                        {{ Reboquista.codigo }}
                      </td>
                      <td
                        @click="open(Reboquista.id)"
                        role="button"
                        tabindex="0"
                        v-if="Reboquista.ativo"
                      >
                        Ativo
                      </td>
                      <td
                        @click="open(Reboquista.id)"
                        role="button"
                        tabindex="0"
                        v-else
                      >
                        Inativo
                      </td>
                      <!-- Ajuste: botão ou link chamando 'abrirModalLocalizacao' -->
                      <td
                        @click.stop="abrirModalLocalizacao(Reboquista)"
                        role="button"
                        tabindex="0"
                      >
                        <button class="btn btn-sm btn-default" v-if="permisaoAcl">Histórico</button>
                      </td>
                    </tr>

                    <tr v-if="!filteredData || filteredData.length === 0">
                      <td colspan="7">Nenhum registro encontrado</td>
                    </tr>

                    </tbody>
                  </table>
                </div>

                <footer class="panel-footer">
                  <div class="row">
                    <div class="col-sm-4 hidden-xs">
                      Mostrar:
                      <select
                        @change="changePage(1)"
                        v-model="pagination.limit"
                        class="input-sm form-control w-auto inline v-middle"
                      >
                        <option
                          v-for="p in paginationLimits"
                          :key="p"
                          :value="p"
                        >
                          {{ p }}
                        </option>
                      </select>
                      por página
                    </div>
                    <div class="col-sm-2 text-center">
                      <small class="text-muted inline m-t-sm m-b-sm">
                        {{ pagination.atualPage }} / {{ pagination.totalPages }}
                      </small>
                    </div>
                    <div class="col-sm-6 text-right text-center-xs">
                      <u-pagination
                        @changePage="changePage"
                        :atual="pagination.atualPage"
                        :total="pagination.totalPages"
                      >
                      </u-pagination>
                    </div>
                  </div>
                </footer>
              </div>

              <!-- Modal de Histórico de Localização -->
              <div v-if="showModalLocalizacao" class="modal-backdrop">
                <div class="modal-container">
                  <div class="modal-content">
                    <!-- Cabeçalho do modal -->
                    <div class="modal-header">
                      <h4 class="modal-title">
                        Histórico de Localização
                        <small v-if="modalReboquista">({{ modalReboquista.nome || 'Reboquista' }})</small>
                      </h4>
                      <button type="button" class="close" @click="fecharModalLocalizacao">
                        &times;
                      </button>
                    </div>

                    <!-- Corpo do modal -->
                    <div class="modal-body">
                      <div class="row form-group">
                        <div class="col-sm-6">
                          <label>Data Inicial</label>
                          <input type="datetime-local" v-model="dataInicial" class="form-control" />
                        </div>
                        <div class="col-sm-6">
                          <label>Data Final</label>
                          <input type="datetime-local" v-model="dataFinal" class="form-control" />
                        </div>
                      </div>

                      <!-- Botão de buscar -->
                      <div class="text-right" style="padding: 10px">
                        <button class="btn btn-primary btn-sm" @click="buscarLocalizacaoPorPeriodo">
                          <i class="fa fa-search"></i> Buscar
                        </button>
                      </div>

                      <div ref="mapContainer" class="map-fullscreen"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- /.col -->
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Reboquista.vue?543406ce